import { api } from './api';

/**
 * Екран очікування розділу в читалці: анімований значок (public/img/loading.svg) і
 * під ним білий текст "Завантаження". Для джерел, де сервер спершу завантажує
 * розділ на диск (mangarama), текст показує ще й прогрес: "Завантаження 12/41 (29%)".
 */
const PROGRESS_PLUGINS = new Set(['mangarama']);
const POLL_MS = 400;

export function chapterLoadingHtml(): string {
  return (
    '<div class="chapter-loading" role="status" aria-live="polite">' +
    '<img class="chapter-loading__icon" src="/img/loading.svg" alt="">' +
    '<p class="chapter-loading__text">Завантаження</p>' +
    '</div>'
  );
}

/**
 * Поки триває запит розділу, опитує сервер про прогрес і оновлює текст під значком.
 * Повертає функцію зупинки — її треба викликати, щойно розділ отримано (або сталась помилка).
 * Для джерел без прогресу нічого не робить.
 */
export function trackChapterProgress(root: HTMLElement, pluginId: string, chapterPath: string): () => void {
  if (!PROGRESS_PLUGINS.has(pluginId)) return () => {};

  let stopped = false;
  let timer: ReturnType<typeof setTimeout> | undefined;

  const tick = async () => {
    if (stopped) return;
    try {
      const p = await api.chapterProgress(pluginId, chapterPath);
      const el = root.querySelector('.chapter-loading__text');
      if (stopped || !el) return; // розділ уже показано (або екран очікування замінено) — далі не опитуємо
      el.textContent =
        p.active && p.total > 0 ? `Завантаження ${p.done}/${p.total} (${Math.round((p.done / p.total) * 100)}%)` : 'Завантаження';
    } catch {
      /* прогрес — лише прикраса: збій опитування не має заважати завантаженню розділу */
    }
    if (!stopped) timer = setTimeout(tick, POLL_MS);
  };
  timer = setTimeout(tick, 250);

  return () => {
    stopped = true;
    if (timer) clearTimeout(timer);
  };
}
